import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { AppDetailsModalComponent } from '../app-details-modal/app-details-modal.component';
import { MainService } from '../services/main.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-allapps',
  templateUrl: './allapps.component.html',
  styleUrls: ['./allapps.component.css']
})
export class AllappsComponent implements OnInit {
  constructor(public main: MainService, private spinner: NgxSpinnerService, public dialog: MatDialog, private route: ActivatedRoute, private router: Router) { }
  currentPage = 1;
  totalItems = 0;
  pageSize = 6;
  pageSizeOptions: any
  async ngOnInit() {
    this.pageSize = 6;
    this.pageSizeOptions = [3, 6, 9, 12, 15, 18]
    await this.getAllApplications()
    await this.allApps()
  }
  hierarchicalDatashow = []
  app_id
  async getAllApplications() {
    this.hierarchicalDatashow = []
    this.spinner.show()
    let resp = await this.main.getAllApplications()
    if (resp['error'] == false) {
      this.spinner.hide()
      this.app_id = resp['data'][0]['di_id']
      this.totalItems = resp['data'][0]['cl'].length
      this.hierarchicalDatashow = resp['data'][0]['cl'];
      this.filteredItems = this.hierarchicalDatashow;
      const defaultDescription = "This is the Default Description";

      this.filteredItems.forEach(obj => {
        if (!obj.cl_desc) {
          obj.cl_desc = defaultDescription;
        }
      });

      //this.hierarchicalDatashow = resp['data'][0]['cl']
      await this.paginatedData()
    }
    else {
      this.spinner.hide()
      throw new Error('Failed to fetch Apps from the API');
    }
  } catch(error) {
    this.spinner.hide()


  }
  hierarchicalData = []
  async paginatedData() {
    this.filteredItems = []
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    this.filteredItems = this.hierarchicalDatashow.slice(start, end);
  }
  onPageChange(page: number) {
    this.currentPage = page;
    this.paginatedData();
  }
  Pagesizechange(size: number) {
    this.pageSize = size
    //console.log(this.pageSize);

  }
  filteredItems: any[];
  searchTerm: string;
  async applyFilter() {
    //console.log(this.searchTerm);

    if (!this.searchTerm) {
      // this.filteredItems = this.hierarchicalDatashow;
      await this.paginatedData()
      return;
    }

    this.filteredItems = this.hierarchicalDatashow.filter(item =>

      item.cl_cd.toLowerCase().includes(this.searchTerm.toLowerCase())
      // item.di_bus_nm.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }
  async onAddButtonClick() {

    await this.openDialog()
  }
  async openDialog() {
    const dialogRef = this.dialog.open(AppDetailsModalComponent, {
      width: '400px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(async result => {
      //console.log('The dialog was closed', result);
      await this.insertApp(result)

    });
  }
  async insertApp(data) {
    let columns = ['di_id', 'cl_cd'];

    let values = [this.app_id, data['cl_cd']];


    if (data['cl_val']) {
      columns.push('cl_val');
      values.push(data['cl_val']);
    }
    if (data['cl_desc']) {
      columns.push('cl_desc');
      values.push(data['cl_desc']);
    }
    if (data['cl_tcd_json']) {
      columns.push('cl_tcd_json');
      values.push(data['cl_tcd_json']);
    }

    let req_obj = {
      pf_path: 'dd',
      pf_name: 'cl',
      app_cd: 'DD',
      columns: columns,
      values: values
    };
    try {
      let resp = await this.main.addData(req_obj);

      if (!resp['error']) {
        await this.getAllApplications()

        Swal.fire('Success!', 'APP has been added successfully.', 'success');
      } else {

        Swal.fire('Error!', 'Failed to  add app.', 'error');
      }
    } catch (error) {

      //console.error('Error adding app:', error);
      Swal.fire('Error!', 'Failed to  add app.', 'error');
    }


  }
  async modify(app) {
  }
  async view(app) {
    let itemObj = window.btoa(JSON.stringify({
      app: app,
    }))
    this.router.navigate(['./data-eng'], { relativeTo: this.route.parent, queryParams: { id: itemObj } });

  }
  appsstatus = {}
  appchanges = {}
  async allApps() {
    this.appsstatus = {}
    this.appchanges = {}
    let resp = await this.main.getAllAppsstatus()
    //console.log(resp);

    if (resp['error'] == false) {
      let apps = resp['data']?.['apps']
      apps.forEach((ele) => {
        this.appsstatus[ele['app_cd']] = ele['active']
        this.appchanges[ele['app_cd']] = ele['app_config_changed']
      })

      //  this.appsstatus
      //console.log(this.appsstatus);


    }
    else {
      throw new Error('Failed to fetch Apps from the API');
    }
  }
  async initializeApp(node: any) {
    await this.finalinitialize(node)
  }
  async finalinitialize(node) {
    let req_obj = new Object()
    req_obj['app_cd'] = node['cl_cd']
    req_obj['clear'] = true,
      req_obj['reload'] = true
    try {
      this.spinner.show()
      const resp = await this.main.initializeApp(req_obj);

      if (!resp.error) {

        this.spinner.hide()
        Swal.fire('Info!', 'App initialized successfully.', 'success');
        await this.allApps()
      } else {
        this.spinner.hide()
        Swal.fire('Error!', 'Failed to initialize App', 'error');
      }
    } catch (error) {
      this.spinner.hide()
      //console.error('Error initialize App', error);
      Swal.fire('Error!', 'Failed to initialize App', 'error');
    }

  }
  async stopapp(node): Promise<void> {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to Stop the app`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, stop it!'
    });
    if (result.isConfirmed) {
      await this.finalstopapp(node)

    }
  }
  async finalstopapp(node) {
    let req_obj = new Object()
    req_obj['app_cd'] = node['cl_cd']

    try {
      this.spinner.show()
      const resp = await this.main.pauseApplication(req_obj);

      if (!resp.error) {
        this.spinner.hide()

        Swal.fire('Info!', 'App Stopped successfully.', 'success');
        await this.allApps()


      } else {
        this.spinner.hide()
        Swal.fire('Error!', 'Failed to Stopped App', 'error');
      }
    } catch (error) {
      this.spinner.hide()
      //console.error('Error Stop App', error);
      Swal.fire('Error!', 'Failed to Stop App', 'error');
    }
  }
  async autoRenew(app) {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to Restart the app`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, restart it!'
    });
    if (result.isConfirmed) {
      await this.finalstopapp(app)
      await this.initializeApp(app)
    }
  }
}





